import { Component, OnInit } from '@angular/core';
import { Appraisal } from '../../../shared/model/appraisal';
import { Equipment } from '../../../shared/model/equipment';
import { EquipmentService } from '../../../shared/service/equipment.service';
import { EquipmentModelService } from '../../../shared/service/equipment-model.service';
import { TelecomProviderService } from '../../../shared/service/telecom-provider.service';
import { EquipmentTypeService } from '../../../shared/service/equipment-type.service';
import { AppraisalService } from '../../service/appraisal.service';
import { ReturnReason } from '../../model/return-reason';
import { EquipmentType } from '../../../shared/model/equipment-type';
import { EquipmentModel } from '../../../shared/model/equipment-model';
import { SimCard } from '../../../shared/model/sim-card';
import { Access } from '../../../shared/model/access';
import * as moment from 'moment';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { TelecomProvider } from '../../../shared/model/telecom-provider';
import { Router, ActivatedRoute } from '@angular/router';
import { AppraisalTestService } from '../../service/appraisal-test.service';
import { DatePipe } from '../../../shared/pipe/date.pipe';
import { JiraTicketService } from '../../service/jira-ticket.service';
import { SafeUrlPipe } from '../../../shared/pipe/safe-url.pipe';
import { DomSanitizer } from '@angular/platform-browser';
import { ToastService } from '../../../shared/service/toast.service';

declare var Materialize: any;

@Component({
  selector: 'tx-appraisal-create-update',
  templateUrl: './appraisal-create-update.component.html',
  styleUrls: ['./appraisal-create-update.component.css']
})
export class AppraisalCreateUpdateComponent implements OnInit {
  newAppraisal: Appraisal;
  equipmentType: any;
  appraisalTestsItems: any;
  equipmentTypes: Array<any>;
  equipmentModels: Array<any>;
  returnReasons: Array<any>;
  telecomProviders: Array<any>;
  equipments: Array<any>;
  files: any;
  datePipe: DatePipe;
  equipmentIdentifier = 'Serial';
  equipmentIdentifierAttribute = ['serial'];
  isTracker = true;
  invoiceNumberDisabled = true;
  private editMode = false;
  private appraisalId: number;
  ticketInput: Subject<any>;

  constructor(private _equipmentService: EquipmentService,
              private _equipmentModelService: EquipmentModelService,
              private _equipmentTypeService: EquipmentTypeService,
              private _appraisalService: AppraisalService,
              private _router: Router,
              private _route: ActivatedRoute,
              private _appraisalTestService: AppraisalTestService,
              private _jiraTicketService: JiraTicketService,
              private _sanitizer: DomSanitizer,
              private _toastService: ToastService) {
    this.setEmptyEntites();
    this.findEquipmentTypes();
    this.findReturnReasons();
    this.setPipes();
    this.editModeVerify();
    this.setUpObservers();
  }

  ngOnInit() {
  }

  setEmptyEntites() {
    this.newAppraisal = new Appraisal();
    this.newAppraisal.reusable = false;
    this.newAppraisal.equipment = new Equipment();
    this.newAppraisal.equipment.equipmentModel = new EquipmentModel();
    this.newAppraisal.equipment.simCard = new SimCard();
    this.newAppraisal.equipment.simCard.access = new Access();
    this.newAppraisal.equipment.simCard.telecomProvider = new TelecomProvider();
    this.equipments = new Array();
    this.files = new Array();
    this.newAppraisal.files = new Array();
    this.ticketInput = new Subject<any>();
    this.setAppraisalDate();
  }

  save() {
    if (this.setAppraisalTests()) {
      const files = this.assembleCorrectFilesList();
      if (!this.editMode) {
        this._appraisalService.save(this.newAppraisal, files);
      } else {
        this._appraisalService.update(this.newAppraisal, files);
      }
    } else {
      this.showMessage('É necessário selecionar pelo menos um resultado para cada item de teste.');
    }
  }

  goBack() {
    this._router.navigate(['appraisals', 'list']);
  }

  editModeVerify() {
    this._route.params.subscribe(params => {
      if (params['id']) {
        this.editMode = true;
        this.appraisalId = +params['id'];
        this._appraisalService.findById(this.appraisalId);
        this._appraisalTestService.findAsMap(this.appraisalId);
      }
    });
  }

  findEquipments(identifier) {
    if (this.isTracker) {
      this._equipmentService.findBySerial(identifier);
    } else {
      this._equipmentService.findByImei(identifier);
    }
  }

  findReturnReasons() {
    this._appraisalService.findReturnReasons();
  }

  findTestItems() {
    this._appraisalTestService.createAsMap(this.equipmentType);
  }

  findEquipmentTypes() {
    this._equipmentTypeService.findAll();
  }

  setUpObservers() {
    this.setUpTicketInputObserver();

    this._jiraTicketService.find$
      .subscribe(jiraTicket => {
        this.newAppraisal.os = jiraTicket.os;
        this.invoiceNumberDisabled = !!jiraTicket.invoiceNumber;
        this.newAppraisal.invoiceNumber = jiraTicket.invoiceNumber;
        this.newAppraisal.equipment = jiraTicket.equipment;
        this.newAppraisal.entryDate = new Date(jiraTicket.created);
        if (jiraTicket.equipment) {
          this.equipmentType = jiraTicket.equipment.equipmentModel.equipmentManufacturer.equipmentType;
        }
        this.findTestItems();
      });

    this._jiraTicketService.error$
      .subscribe(error => {
        this.appraisalTestsItems = null;
        this.showMessage(error.text);
      });

    this._equipmentTypeService.find$
      .subscribe(equipmentTypes => this.equipmentTypes = equipmentTypes);

    this._appraisalService.find$
      .filter(reasons => reasons instanceof ReturnReason)
      .subscribe(reasons => this.returnReasons = reasons);

    this._equipmentModelService.find$
      .subscribe(models => this.equipmentModels = models);

    this._equipmentService.find$
      .subscribe(equipments => this.equipments = equipments);

    this._appraisalTestService.find$
      .subscribe(testItems => {
        this.appraisalTestsItems = testItems;
        this.handleEmptyTestItems();
      });

    this._appraisalService.save$
      .subscribe(() => this._router.navigate(['appraisals', 'list']));

    this._appraisalService.find$
      .filter(appraisal => appraisal instanceof Appraisal)
      .subscribe(
        appraisal => {
          this.equipmentType = appraisal.equipment.equipmentModel.equipmentManufacturer.equipmentType;
          this.newAppraisal = appraisal;
        }
      );

    this._appraisalService.error$
      .subscribe(error => {
        this.showMessage(error.text);
      });
  }

  fileChange(event) {
    const tempFiles = event.target.files;
    for (let i = 0; i < tempFiles.length; i++) {
      const reader = new FileReader();
      reader.onload = (otherEvent: any) => {
        this.files.push({id: i, url: this.sanitizeUrl(otherEvent.target.result), file: event.target.files[i]});
      };
      reader.readAsDataURL(event.target.files[i]);
    }
  }

  sanitizeUrl(url) {
    return this._sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  appraisalHasFiles() {
    return this.newAppraisal.files.find(file => !file.delete);
  }

  removeFileFromInMemoryList(files, file) {
    const fileIndex = files.indexOf(file);
    files.splice(fileIndex, 1);
  }

  removeFileFromAppraisal(file) {
    const fileToDelete = this.newAppraisal.files.find(f => f.id === file.id);
    fileToDelete.delete = true;
  }

  checkAsReusable() {
    this.newAppraisal.reusable = !this.newAppraisal.reusable;
  }

  checkTestItems(option, testItem) {
    if (option.result) {
      option.result = false;
    } else {
      if (option.appraisalTestTypeHasAppraisalTestItem.appraisalTestItem.name.toLowerCase() === 'normal') {
        this.deselectOptions(testItem);
      } else {
        this.deselectNormal(testItem);
      }
      option.result = true;
    }
  }

  getObjectKeys(object) {
    if (object) {
      return Object.keys(object);
    }
    return [];
  }

  setAppraisalDate() {
    if (!this.newAppraisal.appraisalDate) {
      this.newAppraisal.appraisalDate = new Date();
    }
  }

  getEquipmentEmptyListText() {
    return 'Digite o ' + this.equipmentIdentifier;
  }

  getTypedValue() {
    if (this.newAppraisal.equipment.serial || this.newAppraisal.equipment.imei) {
      if (this.isTracker) {
        return this.newAppraisal.equipment.serial;
      } else {
        return this.newAppraisal.equipment.imei;
      }
    }
    return '';
  }

  formatDate(date) {
    if (date) {
      return moment(date).format('DD/MM/YYYY HH:mm');
    }
    return null;
  }

  applyDateMask(event) {
    return this.datePipe.transform(event.target.value, event.key);
  }

  private handleEmptyTestItems() {
    const notEmpty = Object.keys(this.appraisalTestsItems)
      .some(item => this.appraisalTestsItems[item].length > 0);
    if (!notEmpty) {
      this.findTestItems();
    }
  }

  private setUpTicketInputObserver() {
    this.ticketInput
      .map((event: any) => event.target.value)
      .debounceTime(750)
      .distinctUntilChanged()
      .flatMap(search => Observable.of(search).delay(500))
      .subscribe(typedValue => {
        if (typedValue && typedValue !== '') {
          this.newAppraisal.os = null;
          this.newAppraisal.invoiceNumber = null;
          this.newAppraisal.equipment = new Equipment();
          this._jiraTicketService.findJiraTicket(typedValue);
        }
      });
  }

  private showMessage(message) {
    if (message) {
      this._toastService.showMessage(message, 4000);
    }
  }

  private assembleCorrectFilesList() {
    const newFiles = new Array();
    this.files.forEach(file => {
      newFiles.push(file.file);
    });
    return newFiles;
  }

  private deselectOptions(testItem) {
    this.appraisalTestsItems[testItem].forEach(option => {
      option.result = false;
    });
  }

  private deselectNormal(testItem) {
    this.appraisalTestsItems[testItem].forEach(option => {
      if (option.appraisalTestTypeHasAppraisalTestItem.appraisalTestItem.name.toLowerCase() === 'normal') {
        option.result = false;
      }
    });
  }

  private setAppraisalTests(): boolean {
    let isChecked = true;
    this.newAppraisal.appraisalTests = new Array();
    for (const key of this.getObjectKeys(this.appraisalTestsItems)) {
      isChecked = this.validateTestItems(this.appraisalTestsItems[key]);
      if (isChecked) {
        this.newAppraisal.appraisalTests = this.newAppraisal.appraisalTests.concat(this.appraisalTestsItems[key]);
      } else {
        this.newAppraisal.appraisalTests = new Array();
        break;
      }
    }
    return isChecked;
  }

  private setPipes() {
    this.datePipe = new DatePipe();
  }

  private validateTestItems(testItems) {
    if (testItems && testItems.length > 0) {
      let isChecked = false;
      testItems.forEach(item => {
        if (item.result) {
          isChecked = true;
        }
      });
      return isChecked;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// /home/jenkins/workspace/production-argos-front/argos/src/app/appraisal/component/appraisal-create-update/appraisal-create-update.component.ts